{
  "2": "Successfully saved Third Parties.",
  "3": "Waiting to be loaded.",
  "4": "Error while saving Third Parties.",
  "5": "Successfully saved into staging database.",
  "6": "Error while saving into staging database.",
  "7": "Successfully saved into ICS.",
  "8": "Error while processing into ICS.",
  "9": "Successfully processed into ICS and Alfa.",
  "10": "Error while saving to Alfa.",
  "11": "Resubmitting Proposal",
  "100": "Error while saving to ICS.",
  "101": "Error while processing in Loaders.",
  "102": "Unsupported Country"
}
